import { InjectionToken } from '@angular/core';

export const PRIZM_TREE_SELECT_ITEM_LEVEL = new InjectionToken<number>('PRIZM_TREE_SELECT_ITEM_LEVEL');
export const PRIZM_TREE_SELECT_ITEM_CHILDREN = new InjectionToken<any[]>('PRIZM_TREE_SELECT_ITEM_CHILDREN');
export const PRIZM_TREE_SELECT_ITEM_PARENTS = new InjectionToken<any[]>('PRIZM_TREE_SELECT_ITEM_PARENTS');
export const PRIZM_TREE_SELECT_ITEM = new InjectionToken<any>('PRIZM_TREE_SELECT_ITEM');
